<!-- @format -->

<ng-container *transloco="let t">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="row">
    <sis-validation-error-summary
      [validationErrorDetails]="validationDetails"
      [description]="t('STUDENT_APPLICATIONS.EXTENSION_APPLICATION.INPUT_ERROR_SUMMARY_DESCRIPTION')" />
    <div class="offset-md-1 col-md-10 offset-lg-2 col-lg-8">
      <app-extension-application-study-progress-and-plan-info
        [automaticallyFilledApplicationFields]="automaticallyFilledApplicationFields"
        [attainedCreditsByStudyTerm]="planData.attainedCreditsByStudyTerm"
        [creditsPerTerm]="planData.creditsPerTerm"
        [plannedStudies]="planData.plannedStudies" />

      <div class="row">
        <div class="col-12 col-md-6 col-lg-4">
          <h2>{{ t("STUDENT_APPLICATIONS.EXTENSION_APPLICATION.APPLIED_EXTENSION") }}</h2>
          <div class="form-group">
            <label [ngClass]="getLabelState(form.controls.requestedTerms)">
              {{ t("STUDENT_APPLICATIONS.EXTENSION_APPLICATION.APPLIED_EXTENSION_PERIOD") }}
            </label>
            <sis-dropdown-select
              sisAutofocus
              [id]="'requested-terms-focus-id'"
              [control]="form.controls.requestedTerms"
              [options]="requestedTermsOptions"
              [required]="true" />
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <p class="guidance">{{ t("PROFILE.APPLICATIONS.EXTENSION_APPLICATION.SENSITIVE_INFO_NOTIFICATION") }}</p>
            <sis-text-field
              sisAutofocus
              [id]="'delay-rationale-focus-id'"
              [control]="form.controls.delayRationale"
              [label]="t('STUDENT_APPLICATIONS.EXTENSION_APPLICATION.DELAY_RATIONALE')"
              [textarea]="true"
              [helpBlock]="'PROFILE.APPLICATIONS.EXTENSION_APPLICATION.DELAY_RATIONALE_DESCRIPTION'" />
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <sis-text-field
              sisAutofocus
              [id]="'application-rationale-focus-id'"
              [control]="form.controls.applicationRationale"
              [label]="t('STUDENT_APPLICATIONS.EXTENSION_APPLICATION.APPLICATION_RATIONALE')"
              [textarea]="true"
              [helpBlock]="'PROFILE.APPLICATIONS.EXTENSION_APPLICATION.APPLICATION_RATIONALE_DESCRIPTION'" />
          </div>
        </div>
        <div class="col-12">
          <div class="form-group checkbox-group">
            <h3>{{ t("PROFILE.APPLICATIONS.DECISION_AND_DELIVERY") }}</h3>
            <p class="help-block">{{ t("PROFILE.APPLICATIONS.DECISION_AND_DELIVERY_INFO") }}</p>
            <sis-radio-button
              sisAutofocus
              [id]="'must-print-decision-focus-id'"
              [control]="form.controls.mustPrintDecision"
              [value]="false"
              label="PROFILE.APPLICATIONS.DECISION_DELIVERY_IN_SISU"
              name="mustPrintDecision" />
            <sis-radio-button
              [control]="form.controls.mustPrintDecision"
              [value]="true"
              label="PROFILE.APPLICATIONS.DECISION_DELIVERY_BY_MAIL"
              name="mustPrintDecision" />
          </div>
        </div>

        <div class="col-12 button-holder">
          <sis-button [hollow]="true" (clicked)="exit.emit()">
            <sis-icon icon="back" />
            {{ t("SIS_COMPONENTS.BUTTON.EXIT") }}
          </sis-button>
          <sis-button [type]="'submit'" (clicked)="onSubmit()">
            {{ continueLabel }}
          </sis-button>
        </div>
      </div>
    </div>
  </form>
</ng-container>
